import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectChannelsListWithTvChannel } from 'store/programs/selectors.ts';
import { selectEntitlements } from 'store/user/selectors.ts';

import useChannels from 'screens/Epg/hooks/useChannels.ts';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import EpgChannelList from '../EpgChannelList';
import EpgProgramList from '../EpgProgramList';
import styles from './styles';
import { EpgListProps, IChannelList, IProgramList } from './types';

const EpgListContent = forwardRef<IProgramList, EpgListProps>(
    ({ selectedFilterCategory }, ref) => {
        const { t } = useTranslation();

        const programListRef = useRef<IProgramList>(null);
        const listRef = useRef<IChannelList | null>(null);

        const channelsList = useSelector(selectChannelsListWithTvChannel);
        const entitlements = useSelector(selectEntitlements);

        const channels = useChannels({
            channels: channelsList,
            filterCategory: selectedFilterCategory,
            entitlements,
        });

        useImperativeHandle(
            ref,
            () => ({
                scrollToNow: (animated?: boolean) => {
                    programListRef.current?.scrollToNow(animated);
                },
                scrollToTime: (time: number, animated?: boolean) => {
                    programListRef.current?.scrollToTime(time, animated);
                },
            }),
            [],
        );

        if (!channels.length) {
            return (
                <View style={styles.rootNoChannels}>
                    <Text
                        style={styles.noChannelsText}
                        category={ETextCategory.body1}
                        color={ETextColor.light_grey}
                        center
                    >
                        {t('EMPTY_CONTENT_EPG_FILTER')}
                    </Text>
                </View>
            );
        }

        return (
            <View style={styles.root}>
                <EpgChannelList
                    selectedFilterCategory={selectedFilterCategory}
                    ref={listRef}
                />
                <EpgProgramList
                    selectedFilterCategory={selectedFilterCategory}
                />
            </View>
        );
    },
);

export default EpgListContent;
